import apiClient from '@/services/api'

export default {
  async getDisciplinaryActions({ rootState }, filters = {}) {
    try {
      const params = Object.entries({
        ...filters,
        project_id: rootState.applicationState.currentProject.id,
        types: filters.types?.length ? filters.types.join(',') : undefined
      }).reduce((result, [key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          result[key] = value
        }

        return result
      }, {})

      const { data } = await apiClient.get('/api/disciplinary/actions', { params })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(data.msg)
      }

      return data
    } catch (error) {
      throw error.message
    }
  }
}
